
import { useCallback, useMemo, useState } from 'react';
import JSONPretty from 'react-json-pretty';
import { CommonProperties } from '../common/common.interfaces';
import BlobModalComponent from '../blobs/BlobModalComponent';
import { CUSTOM_JSON_THEME } from '../common/common.constants';
import OrdersTable from './components/OrdersTable';

interface OrdersProps extends CommonProperties {}

export default function Orders(props: OrdersProps){
  const [modalTitle, setModalTitle] = useState('')
  const [modalContent, setModalContent] = useState('')
  const [modalVisible, setModalVisible] = useState(false)

  const handleShowContent = useCallback((e) => {
    const {title, content} = e.currentTarget.dataset
    setModalTitle(title)
    setModalContent(content)
    setModalVisible(true)
  }, [])

  const playSound = () => {
    const audio = new Audio('385818__tec_studio__ominous_horn.wav');
    audio.play();
  };

  const view = useMemo(() => {
    return <div>
      
      <BlobModalComponent raw={modalContent} blobData={<JSONPretty data={modalContent} theme={CUSTOM_JSON_THEME} style={{fontSize: '1.5em'}} />} blobName={modalTitle} closeModal={() => {setModalVisible(false)}} modalVisible={modalVisible === true}/>
      <div id='top'></div>
      <div className='beacon-card'>
        <span style={{ float: 'right', cursor: 'pointer'}}>
          <img onClick={playSound} style={{borderRadius: '5px', height: '50px', width: '50px'}} src='bifrost.png'></img>
        </span>
        <table className='beacon-table'>
          <tbody>
            <tr>
              <td><span className='beacon-header'>Orders</span></td>
            </tr>
            <tr>
              <td><span className='beacon-label'>View recent order items that have been loaded into Mission Control.</span></td>
            </tr>
          </tbody>
        </table>
      </div>
      <br/>
      <OrdersTable handleShowContent={handleShowContent} />
    </div>
  }, [modalTitle, modalContent, modalVisible])

  return view
}
